<template>
  <div>
    <MaintenanceAlert v-if="hasMaintenanceLianLianTicket" />
    <div v-else>
      <div
        v-if="detailInfo"
        :class="hasStepGuide ? 'in-process-step-guide' : 'top-up-in-process'"
      >
        <top-up-success
          class="summary-form"
          :detail-info="detailInfo"
          :amount="detailInfo.amount"
        />
      </div>
      <b-row
        v-else-if="!showConfirmation"
        class="width-content add-fund-container"
      >
        <b-col
          :md="hasStepGuide ? 12 : 9"
          class="p-0 card-content"
        >
          <div
            class="lianlian-top-up-amount p-0"
            :class="hasStepGuide ? 'mt-0' : 'mt-2'"
          >
            <!-- :is-toggle="isToggle" -->
            <top-up-amount
              :amount="amount"
              :amount-tip="amountTip"
              :tip-index="currentTipIndex"
              :show-tips-input="showTipsForAM"
              @on-confirm="handleShowConfirm"
            />
          </div>
        </b-col>
      </b-row>

      <b-row
        v-else
        class="width-content add-fund-container"
      >
        <b-col
          :md="hasStepGuide ? 12 : 9"
          class="card-content p-0"
        >
          <div
            class="lianlian-card-confirm-amount p-0"
            :class="hasStepGuide ? 'mt-0' : 'mt-2'"
          >
            <!-- :is-toggle="isToggle" -->
            <confirm-amount
              :transaction-info="transactionInfo"
              :amount="amount"
              :amount-tip="amountTip"
              :current-tip="currentTip"
              :billing="billing"
              :show-tips-input="showTipsForAM"
              :wallet="wallet"
              @on-prev="handlePrev"
              @handleShowSuccess="handleShowSuccess"
            />
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import TopUpAmount from '@/views/payment/components/LianLianCard/TopUpAmount.vue'
import TopUpSuccess from '@/views/payment/components/LianLianCard/TopUpSuccess.vue'
import envMixin from '@/mixins/envMixin'
import stepGuideMixin from '@/mixins/stepGuideMixin'
import { PAYMENT_GATE_STATUS, PAYMENT_METHOD } from '@/constants'
import { createNamespacedHelpers } from 'vuex'
import ConfirmAmount from '@/views/payment/components/LianLianCard/ConfirmAmount.vue'
import paymentMixin from '@/mixins/paymentMixin'
import MaintenanceAlert from '@/views/payment/components/MaintenanceAlert.vue'

const { mapGetters } = createNamespacedHelpers('payment')
export default {
  components: {
    MaintenanceAlert,
    BRow,
    BCol,
    TopUpAmount,
    TopUpSuccess,
    ConfirmAmount,
  },

  mixins: [envMixin, stepGuideMixin, paymentMixin],

  data() {
    return {
      detailInfo: null,
      showConfirmation: false,
      amount: 0,
      billing: [],
      transactionInfo: '',

      currentTip: null,
      amountTip: null,
      currentTipIndex: null,
      showTipsForAM: false,
      wallet: {},
    }
  },

  computed: {
    ...mapGetters(['listTicket']),
    lianlianTicketPaymentInfo() {
      return this.paymentInfo.lianLianTicket
    },

    lianLianTicketWallet() {
      return this.lianlianTicketPaymentInfo?.info?.map(item => ({
        add: item.to,
      }))
    },

    hasMaintenanceLianLianTicket() {
      return (
        this.paymentInfo?.lianLianTicket?.status
        === PAYMENT_GATE_STATUS.MAINTENANCE
      )
    },
  },

  watch: {
    listTicket: {
      handler(val) {
        if (val) {
          const itemDetail = val?.content?.find(
            item => item?.details?.paymentMethod === PAYMENT_METHOD.LIANLIAN_TICKET
              && item.status === 'opening',
          )
          this.detailInfo = itemDetail?.details
        }
      },
      deep: true,
      immediate: true,
    },
  },

  created() {
    this.setTransferNetwork()
  },

  methods: {
    setTransferNetwork() {
      // eslint-disable-next-line prefer-destructuring
      this.wallet = this.lianLianTicketWallet[0]
    },

    handleShowConfirm(data) {
      this.showConfirmation = true
      this.amount = data.amount
      this.currentTip = data.currentTip
      this.amountTip = data.tipAMAmount
      this.currentTipIndex = data.currentTipIndex
      this.showTipsForAM = data.showTipsForAM
    },

    handlePrev(data) {
      this.showConfirmation = false
      this.amount = data.amount
      this.transactionInfo = data.transactionId
      this.billing = data.billing
      this.currentTip = data.currentTip
      this.amountTip = data.amountTip
      this.showTipsForAM = data.showTipsForAM
    },

    handleShowSuccess(data) {
      this.isShowSuccessPage = data
      this.$emit('handleShowSuccessTabs', this.isShowSuccessPage)
    },
  },
}
</script>
